import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import RTE from '../components/rte.jsx';

const Image = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [id, setId] = useState(location.state?.id);
    const setContext = useContext(Context)[1];
    if (id)
        setContext('Edit Sponsor');
    else
        setContext('Add Sponsor');
    const defaultSponsor = {
        mediaUrl: '',
        name: '',
        type: 'Banner',
        sponsorUrl: '',
        createdDate: '',
        createdBy: '',
        updatedDate: '',
        updatedBy: '',
        details: ''
    }
    const [sponsor, setSponsor] = useState(defaultSponsor);
    const [loading, setLoading] = useState(id ? true : false);
    const [file, setFile] = useState(null);
    const [fp, setFP] = useState('');
    const [deleteImage, setDeleteImage] = useState(false);
    const loadSponsor = () => {
        axios.post(process.env.REACT_APP_API_URL + 'sponsor', {
            id: id
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setSponsor(r.data.results);
            }
        });
    }
    useEffect(() => {
        if (id) {
            loadSponsor();
        } else {
            setLoading(false);
        }
    }, [id]);
    const setValue =(key, value) => {
        setSponsor(h => {
            let _h = { ...h };
            _h[key] = value;
            return _h;
        });
    }
    const save = () => {
        const formData = new FormData();
        formData.append('media', file);
        formData.append('name', sponsor.name);
        formData.append('type', sponsor.type);
        formData.append('code', sponsor.code);
        formData.append('sponsorUrl', sponsor.sponsorUrl);
        formData.append('details', sponsor.details);
        formData.append('mediaUrl', sponsor.mediaUrl);
        formData.append('deleteMedia', deleteImage);
        if (!id) {
            axios.post(process.env.REACT_APP_API_URL + 'sponsor/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setId(r.data.id);
                    setFile(null);
                    setFP('');
                    setDeleteImage(false);
                    setLoading(true);
                }
            });
        } else {
            formData.append('id', id);
            axios.post(process.env.REACT_APP_API_URL + 'sponsor/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setFile(null);
                    setFP('');
                    setDeleteImage(false);
                    setLoading(true);
                    loadSponsor();
                }
            });
        }
    }
    const _delete = () => {
        if (!id)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'sponsor/delete', {
            ids: JSON.stringify([id]),
            urls: JSON.stringify([sponsor.mediaUrl])
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                navigate('/sponsor-list');
            }
        });
    }
    if (loading) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form speaker-form f-start">
                    <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white">
                        <h3 className="mb-10">Sponsor Info</h3>
                        <div className="w-100 gap-10 f-row f-wrap">
                            {sponsor.mediaUrl && !deleteImage ? (
                                <div className="p-rel w-100 f-col f-center">
                                    {sponsor.type == 'Banner' ? (
                                        <img src={process.env.REACT_APP_MEDIA_URL + sponsor.mediaUrl} alt={sponsor.name} />
                                    ) : (
                                        <video controls="controls" src={process.env.REACT_APP_MEDIA_URL + sponsor.mediaUrl} style={{width: '100%'}} />
                                    )}
                                    <button className="btn-remove-media" onClick={() => {
                                        setDeleteImage(true);
                                    }}>
                                        {'\u00D7'}
                                    </button>
                                </div>
                            ) : (
                                <div className="w-100">
                                    <label htmlFor="sponsor-file">Sponsor {sponsor.type == 'Banner' ? 'Banner' : 'Video'}</label>
                                    <input type="file" id="sponsor-file" accept={sponsor.type == 'Banner' ? 'image/*' : 'video/*'} onChange={(e) => { setFile(e.target.files[0]); setFP(e.target.value) }} value={fp} />
                                </div>
                            )}
                            <div className="w-50">
                                <label htmlFor="name">Name</label>
                                <input type="text" id="name" value={sponsor.name} onChange={(e) => setValue('name', e.target.value)} />
                            </div>
                            <div className="w-50">
                                <label htmlFor="type">Type</label>
                                <select id="type" value={sponsor.type} onChange={(e) => setValue('type', e.target.value)}>
                                    <option value="Banner">Banner</option>
                                    <option value="Video">Video</option>
                                </select>
                            </div>
                            <div className="w-50">
                                <label htmlFor="sponsor-url">Sponsor URL</label>
                                <input type="text" id="sponsor-url" value={sponsor.sponsorUrl} onChange={(e) => setValue('sponsorUrl', e.target.value)} />
                            </div>
                            <div className="w-50">
                                <label htmlFor="sponsor-code">Promo Code (Optional)</label>
                                <input type="text" id="sponsor-code" value={sponsor.code} onChange={(e) => setValue('code', e.target.value)} />
                            </div>
                            <div className="w-100">
                                <label htmlFor="sponsor-details">Sponsor/Promo Details</label>
                                <RTE value={sponsor.details} setValue={(v) => setValue('details', v)} />
                            </div>
                        </div>
                    </div>

                    <div className="w-100 f-end f-row">
                        <div className="flex f-center f-row gap-5">
                            <button onClick={save} className="btn btn-green">Save</button>
                            {id && <button onClick={() => {
                                setId(null);
                                setSponsor(defaultSponsor);
                                setFile(null);
                                setFP('');
                                setDeleteImage(false);
                                setLoading(true);
                            }} className="btn">New</button>}
                            <Link className="btn btn-red" to="/sponsor-list">Cancel</Link>
                            {id && <button onClick={_delete} className="btn btn-red">Delete</button>}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Image;